export default {"src":"/_next/static/media/jicama.d5547090.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};